/**
 * Empty pivot query result data set
 *
 * @internal
 */
export const EMPTY_PIVOT_QUERY_RESULT_DATA = {
    table: { columns: [], rows: [] },
};
/**
 * Runs type guard check for DataSource.
 *
 * @param arg
 * @internal
 */
export function isDataSource(arg) {
    return arg === undefined || typeof arg === 'string' || ('title' in arg && 'type' in arg);
}
//# sourceMappingURL=interfaces.js.map